'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { getQueryClient } from './GetQueryClient';
export default function Provider({ children }) {
    const queryClient = getQueryClient();
    return _jsx(QueryClientProvider, { client: queryClient, children: children });
}
